//
//

import PluginContainer from "../PluginContainer/PluginContainer";
import CollapsableContainer from "../CollapsableContainer/CollapsableContainer";

export default {
    name: "PluginSidebar",
    components: {
        PluginContainer,
        CollapsableContainer
    },
    props: {
        pluginCats: Array,
        uiTitle: String,
        uiSubtitle: String,
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        pluginCategories() {
            return this.pluginCats || plugins;
        }
    },
    mounted() {},
    methods: {
        pluginClicked(data) {
            if (!this.readonly) {
                this.$emit("SIDEBAR_CLICKED_PLUGIN", data);
            }
        }
    }
};
